import { IKnmRequirementViolation } from 'APIPackage/KnmModule/interfaces/IKnmRequirementViolation';
import {
  IKnmErknmFormViolation,
  IViolationFixPlanDateItem,
  IViolationFixPlanExplanationItem,
  IViolationMaterialTypeItem,
} from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { booleanSelectOptions } from 'KnmPackage/MainModule/constants/booleanSelectOptions';
import { createViolationMaterialTypeSelectOption } from 'CorePackage/CatalogsModule/common/createViolationMaterialTypeSelectOption';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { createViolationFixMethodSelectOption } from 'CorePackage/CatalogsModule/common/createViolationFixMethodSelectOption';
import { convertKnmDataViolationFixesToFormValues } from 'KnmErknmPackage/MainModule/common/convertKnmDataViolationFixesToFormValues';

import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

const negativeSelectOption = booleanSelectOptions.find(option => !option.value);

export function convertKnmDataViolationsToFormValues(
  violationsData: IKnmRequirementViolation[],
  makeAsNew?: boolean,
): IKnmErknmFormViolation[] {
  return violationsData.map((violation, index) => {
    return {
      id: violation.guid,
      isNew: makeAsNew || !!violation.isNew || false,
      status: violation.status || null,
      title: violation.description,
      descriptionReactQuillEditor: handleReactQuillDeltaValue(
        violation.descriptionReactQuillEditor || violation.description || null,
      ),
      isUnfixable:
        booleanSelectOptions.find(option => option.value === violation.notRemoval) || negativeSelectOption || null,
      isFixedOnPlace:
        booleanSelectOptions.find(option => option.value === violation.correctedInEvent) ||
        negativeSelectOption ||
        null,
      explanation: violation.explanation,
      explanationReactQuillEditor: handleReactQuillDeltaValue(
        violation.explanationReactQuillEditor || violation.explanation,
      ),
      isFixed:
        booleanSelectOptions.find(option => option.value === violation.corrected) || negativeSelectOption || null,
      isAppealed:
        booleanSelectOptions.find(option => option.value === violation.appealed) || negativeSelectOption || null,
      // isFixedInAnotherEvent: violation.correctedInOtherEvent, Для второго этапа SERP2-4294
      // fixedKnmId: violation.linkedId, Для второго этапа SERP2-4294

      fixPlanId: violation.remediationPlan?.guid || null,
      fixPlanDates: violation.remediationPlan?.plannedEliminationDates?.length
        ? violation.remediationPlan.plannedEliminationDates.map<IViolationFixPlanDateItem>(dateItem => ({
            ...dateItem,
            isNew: !!dateItem.isNew,
            value: convertInitialKnmDateToFormDate(dateItem.value, DATE_FORMAT_LONG_FNS) || null,
          }))
        : null,
      fixPlanMethods: violation.remediationPlan?.plannedMethod?.length
        ? violation.remediationPlan.plannedMethod.map<IViolationMaterialTypeItem>(methodDTO => ({
            isNew: !!methodDTO.isNew,
            value: createViolationMaterialTypeSelectOption(methodDTO),
          }))
        : null,
      fixPlanExplanations: violation.remediationPlan?.descriptions?.length
        ? violation.remediationPlan.descriptions.map<IViolationFixPlanExplanationItem>(explanationItem => ({
            ...explanationItem,
            isNew: !!explanationItem.isNew,
            value: explanationItem.value,
            valueReactQuillEditor: handleReactQuillDeltaValue(
              explanationItem.valueReactQuillEditor || explanationItem.value,
            ),
          }))
        : null,

      fixFactDate: convertInitialKnmDateToFormDate(violation.actualEliminationDate, DATE_FORMAT_LONG_FNS) || null,
      fixFactMethod: violation.actualMethod ? createViolationFixMethodSelectOption(violation.actualMethod) : null,

      fixes: violation.eliminationViolations?.length
        ? convertKnmDataViolationFixesToFormValues(violation.eliminationViolations)
        : null,

      updatedBy: violation.updatedBy,
      updated: violation.updated,

      // Todo проработать модель айтема связи, чтобы отобразить название мероприятия
      // Для второго этапа SERP2-4294
      // connections: violation.linkedIds?.length
      //   ? violation.linkedIds.map(link => ({ linkId: link.id, type: link.type, title: '' }))
      //   : null,
      isViolationResolved: booleanSelectOptions.find(item => item.value === violation.isViolationResolved) || undefined,
      isViolationResolvedNote: violation.isViolationResolvedNote || undefined,
      dateResolvedByAgreement:
        convertInitialKnmDateToFormDate(violation.dateResolvedByAgreement, DATE_FORMAT_LONG_FNS) || undefined,
      previousDateResolvedByAgreement:
        convertInitialKnmDateToFormDate(violation.previousDateResolvedByAgreement, DATE_FORMAT_LONG_FNS) || undefined,
      includeInSubject: typeof violation.includeInSubject === 'boolean' ? violation.includeInSubject : undefined,
      prescriptionLink: violation.prescriptionLink || undefined,
      number: violation.number || String(index + 1),
      repeatCorrected: booleanSelectOptions.find(option => option.value === violation.repeatCorrected) || null,
      repeatCorrectedInEvent:
        booleanSelectOptions.find(option => option.value === violation.repeatCorrectedInEvent) ||
        negativeSelectOption ||
        null,
      repeatExplanation: violation.repeatExplanation,
      targetLink: violation.targetLink || undefined,
      targetErpId: violation.targetErpId || undefined,
      resolvedIn: violation.resolvedIn || undefined,
    };
  });
}
